/* tslint:disable */
var TSlipShared = (function () {
    var api = <any>{},
    minStakeValue = Bets.getMinStakeValue();

    var createStakeButton = function (classSuffix, value?) {
        var inactive = "";
        var handler = classSuffix === "Plus" ? "inc(this)" : "dec(this)";
        var stakeBoxSignClass = classSuffix === "Plus" ? "i-o-betslip-plus-alt" : "i-o-betslip-minus-alt";

        if (value) {
            value = typeof value === "string" ? StakeInputParser.parse(value) : value;
            inactive = value <= minStakeValue ? "inactive" : ""
        }

        return `
            <a href="javascript:void(0)" class="stakeboxActionsBtn stakeboxActions${classSuffix} ${inactive}" onclick="${handler}">
                <span class="icon i-24 ${stakeBoxSignClass}"></span>
            </a>
        `;
    };

    api.createStakeInputAttributes = function (changeHandler, keyUpHandler) {
        keyUpHandler = keyUpHandler ? keyUpHandler: changeHandler;
        return `
            type="text" inputmode="decimal" step="any" min="0" onfocus="showHideZero(this, true)" onblur="showHideZero(this, false);" onchange="${changeHandler}" onkeyup="${keyUpHandler}"
        `;
    };

    api.createStakeBox = function (createInner, value) {
        var innerHtml = [];
        createInner(innerHtml);
        return `
            <div class="stakeboxActions ">
                ${innerHtml.join('')}
                ${createStakeButton("Plus")}
                ${createStakeButton("Minus", value)}
            </div>
        `;
    };

    // tsingle/tcombo/tsystem/tteaser.js - buildSelectionInnerView
    api.createRemoveButton = function (viewKey) {
        var customImg = (BetSlip.ImageForXSign) ? 'style="background-image: url(\'' + BetSlip.ImageForXSign+'\');"' : '';
        return `
            <a class="betSlip_row_remove" href="javascript:UniSlipBlock.removeBet(${viewKey});" data-uat="delete-bet">
                <span class="icon i-12 i-o-betslip-clear" ${customImg}>
    				${$string('General').DeleteBet}
    			</span>
            </a>
        `;
    };

    // tsingle/tcombo/tsystem/tteaser.js - buildSelectionLoadingBox
    api.createLoadingBox = function (selection) {
        return TSlipShared[BetSlipTemplateConroller.getLoadingBoxTemplate(BetSlip.TemplateType)](selection);
    };

    api.createRegularLoadingBox = function(selection) {
        return `
        <div class="loading">
            ${api.createLoader()}
            <strong>${$dict.bs("Loading")}</strong>
        </div>
        `;
    };

    api.createResponsiveLoadingBox = function() {
        return ResponsiveHTMLTemplate.base.getTemplate("Loader").buildLoaderWithText({
            wrapperClasses: "betSlip-message-loader betSlip-message-selection preloader-on-the-right",
            text: "<strong>" + $dict.bs("Loading") + "</strong>",
            loaderClasses: "preloader-betslip"
        });
    };

    api.createLoader = function () {
        return ResponsiveHTMLTemplate.base.getTemplate('Loader').buildLoader('preloader-reg-betslip');
    }

    // tsingle/tcombo/tsystem/tteaser.js - buildSelectionNoDataClosedView
    api.createNoDataBox = function (selection) {
        return `
            <div class="betSlip_row_content">
                <div>
                    <p>
                        <strong>${$dict.bs("PickNO")}</strong>
                    <p>
                </div>
            </div>
        `;
    };

    // tsingle/tcombo/tsystem/tteaser.js - buildSelection after buildSelectionInnerView and buildSelectionStatusBox
    api.createOverlayMessage = function (mode, selection, context) {
        context.hasOverlay = BetSlipUtil.hasOverlay(mode, selection, context);

        if (!Modes.isCombinatorMode(mode) && selection.ComboBetIsEnabled === undefined) {
            context.hasOverlay = context.hasOverlay && selection.ComboBetIsEnabled;
        }

        if (BetSlip.isComboNoCombinationSingleMode()) {
            context.hasOverlay = !selection.ComboBetIsEnabled && BetSlip.getSelectionsCount() > 1;
        }

        if (!context.hasOverlay) {
            return '';
        }

        return `
            <div class="overlayContainer overlay" style="display:block">
                <span class="negative">${selection.Error}</span>
            </div>
        `;
    };

    // tsingle/tcombo/tsystem/tteaser.js - buildSelectionStatusBox in the last else block
    api.createInlineMessage = function (mode, selection, context) {
        if (this.shouldHideInlineMessage(mode, selection, context)) {
            return "";
        }

        var inlineMessage = Selections.getSelectionInlineMessage(mode, selection);

        return api.createMessage(inlineMessage.Text, inlineMessage.Class);
    };

    api.shouldHideInlineMessage = function (mode, selection, context)
    {
        return context.hasOverlay || (!(selection.ComboBetIsEnabled === undefined || selection.ComboBetIsEnabled) && !Modes.isSingleMode(mode));
    };

    api.createBonusBettingMessage = function (mode) {
        if (mode.IsBetPlacedWithBonus) {
            return `<div class="betSlip-message betSlip-message-bonus" data-uat="bonus-message">${$dict.bs("BonusBettingMessage")}</div>`;
        }
        return '';
    };

    api.createMessage = function (text, cssClass) {
        if (!text) {
            return '';
        }

        return TSlipShared[BetSlipTemplateConroller.getMessageTemplate(BetSlip.TemplateType)](text, cssClass);
    };

    api.createRegularMessage = function(text, cssClass) {
        var isError = cssClass === "negative";
        return `
            <div class="betSlip_message ${isError ? "error" : "success"}">
                ${!isError ? api.createLoader() : ""}
                <span class="${cssClass}">${text}</span>
                <div class="arrowElementBorder"></div>
                <div class="arrowElement"></div>
            </div>
        `;
    };

    // Bets in process
    api.createResponsiveMessage = function(text, cssClass) {
        var isError = cssClass === "negative";
        var messageClass = BetSlipStyles.getResponsiveMessageClass(BetSlip, isError);
        var loaderSettings = {
            wrapperClasses: 'preloader-on-the-right',
            textClasses: cssClass,
            text: text,
            loaderCondition: !isError,
            loaderClasses: "preloader-betslip"
        };

        return `
            <div class="betSlip-message ${messageClass}">
                ${ResponsiveHTMLTemplate.base.getTemplate("Loader").buildLoaderWithText(loaderSettings)}
            </div>
        `;
    };

    // tcombo/tsystem/tteaser.js - buildSelectionInnerView
    api.createMultiSelectionBox = function (mode, selection) {
        if (BetSlipUtil.hideSelectionCheckbox(selection, mode)) {
            return "";
        }

        var checked = Selections.isInCombo(mode, selection) ? "checked" : "";

        return `
            <label>
                <input id="combo_check_${selection.ViewKey}" class="chck" type="checkbox" ${checked} onclick="UniSlipBlock.selectMulti(${selection.ViewKey}, this)" data-uat="selection-in-use-checkbox">
                <span class="icon i-24 i-o-controls-checkmark"></span>
            </label>
        `;
    };

    // tsingle - buildSelectionStakeBox
    api.createSingleStakeBox = function (mode, selection) {
        if (!Modes.isSingleMode(mode) || Modes.isComboNoCombinationSingleMode(mode)) {
            return "";
        }

        var isToWin = mode.isToWin(selection),
            action = isToWin ? 'setToWin' : 'setStake',
            stakes = isToWin ? mode.ToWins : mode.Deposits,
            stake = BetSlip.getStakeBoxValue(stakes[selection.ViewKey]),
            freeBetsData = IsUKBetSlip ? Modes.getAvailableFreeBetsForUKSlip(mode, UKSlipModeSubModes.Single, selection, null, null) : Modes.getAvailableSingleFreeBets(mode, selection);

        var __html = "";
        __html += api.createStakeBox(getSingleStakeBoxInner(action, stake, selection), stake);
        if (freeBetsData) {
            __html += api.createFreeBetDropDown(freeBetsData, UKSlipModeSubModes.Single);
        }

        return __html;
    };

    var getSingleStakeBoxInner = function (action, stake, selection) {
        return function (__html) { 
            var changeHandler = "UniSlipBlock." + action + "(" + selection.ViewKey + ", this)";
            var keyUpHandler = "UniSlipBlock." + action + "(" + selection.ViewKey + ", this)";
            var attributes = TSlipShared.createStakeInputAttributes(changeHandler, keyUpHandler),
            formattedStake = BetSlip.getStakeBoxValue(stake);
            __html.push(`
                <input class="stakebox singleDepositField" id="stake_${selection.ViewKey}" data-uat="bet-slip-stakebox" value="${formattedStake}" ${attributes} />
            `);
        }
    };

    // tsingle.js - buildSelectionStakeBox / tcombo/tsystem/tteaser.js - buildSelectionOdds
    api.createPickLineOdds = function (mode, selection, context, skipEW) {
        var isRacingSelection = selection.BranchID == constHorseRacingBranchID || selection.BranchID == constGreyHoundRacingBranchID; 
        var isQASelection = selection.BetType == 7;
        if ( isQASelection && !context.isPurchase && !(!Selections.hasAlternateLine(selection) || (!Modes.isSingleMode(mode) && isRacingSelection)) ) { 
            return createQAOddLine(mode, selection, context); 
        }

        if (!Selections.showPickLineOdds(selection)) { 
            return "";
        }

        var updated = context.isPurchase ? (selection.UpdatedOdds ? "updated" : "") : BetSlipStyles.getOddsUpdatedClassInBetSlipSelection(mode, selection),
            oddsClass = Modes.isSingleMode(mode) ? "odds" : "codds",
            odds = BetSlipUtil.getPickLineOdds(mode, selection, context, skipEW);

        if (context.isPurchase) { 
            if (Modes.isTeaserMode(mode)) {
                return "";
            }
            return `<label class="${updated} ${Odds.getAsianViewClassList(odds)}" data-uat="bet-slip-selection-odds">${$dict.bs("OddsSeparator")} ${odds}</label>`;
        } else {
            return `${$dict.bs("OddsSeparator")} <label id="cOddsToWhow_${selection.ViewKey}" class="${oddsClass} ${updated} ${Odds.getAsianViewClassList(odds)}" data-uat="bet-slip-selection-odds">${odds}</label>`;
        }
    };

    api.createMasterEventDescription = function (selection, team1Name, team2Name) {

        if (selection && typeof eBranches.SoccerAggregates !== "undefined" &&
         selection.BranchID === eBranches.SoccerAggregates && selection.EventName)
        {
             return selection.EventName;
        }

        var vsText = selection && selection.IsTeamSwapEnabled ? $dict.bs("swapAt") : $string("General").VS;
        return `
            <strong>${team1Name}</strong>
            <span>${vsText}</span>
            <strong>${team2Name}</strong>
        `;
    };

    var createQAOddLine = function (mode, selection, context) {
        var updated = context.isPurchase ? (selection.UpdatedOdds ? "updated" : "") : BetSlipStyles.getOddsUpdatedClassInBetSlipSelection(mode, selection),
            spOptions = Selections.getSPOptions(selection),
            odds = BetSlipUtil.getQAOdds(mode, selection, context, spOptions),
            dropdownData = [
                {
                    label: spOptions.first,
                    value: "",
                    selected: !spOptions.spSelected
                },
                {
                    label: spOptions.second,
                    value: $dict.bs("SP"),
                    selected: spOptions.spSelected
                }
            ],
            dropdownOptions = {
                id: "cOddsToWhow_" + selection.ViewKey,
                cssClasses: "dropdown",
                uat: "bet-slip-selection-odds-dropdown",
                inlineHandler: "UniSlipBlock.showAlternateLine(" + selection.ViewKey + ")",
                setData: dropdownData
            };

        return `
            <div class="dropdownBetSlip ${updated} ${Odds.getAsianViewClassList(odds)}">
                ${TFilterTemplate.custom.build(customSelect.config(dropdownOptions))}
            </div>
        `;
    };

    api.createVirtualSportsDescription = function (selection) {
        if (!BetSlipUtil.isVirtualSport(selection.BranchID)) {
            return "";
        }

        return `${$string("General").MatchId}: ${selection.EventID}`;
    };

    api.createScoreDescription = function (selection, tsSelection, mode) {
        if (!selection.Live) {
            return "";
        }

        var scores = Selections.getFormattedScores(selection, tsSelection),
            updated = BetSlipStyles.getScoreUpdatedClassInBetSlipSelection(mode, selection);

        return `
            <label id="cScore_${selection.ViewKey}" class="${updated}" data-uat="bet-slip-selection-live-result">
                [${scores.Score1}:${scores.Score2}]
            </label>
        `;
    };

    api.createOptionsMessage = function (message) {
        return TSlipShared[BetSlipTemplateConroller.getOptionsMessageTemplate(BetSlip.TemplateType)](message);
    };

    api.createRegularOptionsMessage = function (message) {
        if (message) {
            return `
                <div class="betSlip_message">
                    <p>${message}</p>
                </div>
            `;
        }
        return "";
    };

    api.createResponsiveOptionsMessage = function (message) {
        var config = {
            text: "<p>" + message + "</p>",
            loaderCondition: false
        };

        if (message) {
            return `
                <div class="betSlip-message betSlip-message-warning">
                    ${ResponsiveHTMLTemplate.base.getTemplate("Loader").buildLoaderWithText(config)}
                </div>
            `;
        }
        return "";
    };

    // TSingleSPSlipMode.js, TComboSPSlipMode.js, TTeaserSPSlipMode.js - buildFreeBetDropDown
    //subMode is used for UK Slip only
    api.createFreeBetDropDown = function (freeBetsData, subMode) {
        var handler = "UniSlipBlock.setFreeBet('" + freeBetsData.Key + "',this," + subMode + ")";
        return `
            <div class="selectFreeBetHolder alternativeDropdown" data-uat="select-free-bet-holder">
                ${TFilterTemplate.custom.build(setAlternativeDropdownConfig(freeBetsData, handler)) }
           </div>
        `;
    };

    var setAlternativeDropdownConfig = function (freeBetsData, handler) {
        var freeBet, i, len;
        return customSelect.config(
        {
            id: "freeBet_" + freeBetsData.Key,
            inlineHandler: handler,
            firstOption: {
                label: $dict.bs("SelectFreeBet"),
                value: "0",
                selected: !freeBetsData.SelectedID
            },
            uat: "bet-slip-free-bet-dropdown",
            setData: function (data)
            {
                for (i = 0, len = freeBetsData.FreeBets.length; i < len; i += 1)
                {
                    freeBet = freeBetsData.FreeBets[i];
                    data.push(
                    {
                        label: Bets.formatCurrencyStake(freeBet.Amount) + ": " + freeBet.Name,
                        value: freeBet.BonusID,
                        selected: freeBetsData.SelectedID === freeBet.BonusID
                    });
                }
                return data;
            }
        });
    }

    api.createBuyPointsSelect = function (selection) {
        if(!(selection.BuyPoints && selection.BuyPoints.length)) {
            return "";
        }
    
        var viewKey = selection.ViewKey;
        var options = {
            id: "ddBuyPoints_" + viewKey,
            cssClasses: "buyPoints betSlipSelect betSlipSelect--block",
            inlineHandler: "UniSlipBlock.buyPointsAdd(" + viewKey + ")",
            setData: function (data) {
                for (var i = 0, len = selection.BuyPoints.length; i < len; i += 1) {
                    var buyPoint = selection.BuyPoints[i];
                    var buyPointLength = buyPoint.Points.toString().length;
                    var spaceChar = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                    var newString = spaceChar.substring(spaceChar.length, buyPointLength * 6);
                    data.push({
                        label: DefaultNumberFormat.format(buyPoint.Points) + newString + Selections.formatBuyPointOdds(buyPoint),
                        value: buyPoint.Points,
                        selected: Selections.isBuyPointSelected(selection, buyPoint),
                        odds: buyPoint.Odds
                    });
                }
                
                return data;
            },
            uat: "bet-slip-buy-points"
        };
 
        return `
            <div class="stakeBuyPoints">
                ${TFilterTemplate.custom.build(customSelect.config(options))}
            </div>
        `;
    };

    api.createCombinatorGroupSelect = function(mode, selection) {
        if (!Modes.isCombinatorMode(mode) || !selection.CombinatorGroup) { //not a Combinator mode or excluded non-combinable selection
            return "";
        }

        var config = {
            id: "combinator-groups_"+ selection.ViewKey,
            cssClasses: "combinator-options",
            inlineHandler: "BetSlip.Modes['combinator'].updateCombinatorGroups(this," + selection.ViewKey + ")",
            uat: "bet-slip-combinator-options",
            setData: function (data) {
                var groups = mode.getAvailableCombinatorGroups();
                for (var key in groups) {
                    var group = groups[key];
                    data.push({
                        label: group,
                        value: group,
                        selected: group === selection.CombinatorGroup
                    });
                }
                return data;
            }             
        };
        return TFilterTemplate.custom.build(customSelect.config(config));
    };
    
    api.createEditModeHeader = function(message, fold) {
        return `
            <div class="edit-mybets-section clearfix">
                <a class="edit-mybets-cancel-button" onClick="BetSlip.cancelEditMode()">${$dict.bs("CancelEditMode")}</a>
            </div>
            <div class="ukSlipHeading" id="jsUkSinglesHeader">
                ${message} - ${fold}
            </div>
        `;
    };

    api.createMaxBet = function(selection, mode) {
        if (Modes.isSingleMode(mode) && (!Application.deviceType.isDesktop() && typeof (isAsianView) === 'undefined' || !isAsianView) && mode.IsMaxBetButtonEnabled(selection)) {
            return `
                <div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:BetSlip.CurrentMode.setMaxBet(${selection.ViewKey})">${$dict.bs("MaxBet")}</a></div>
            `;
        }

        return "";
    };

    api.createUKMaxBet = function(selection, mode) {
        if(isEnabledMaxBetForSingleSelectionUK(selection)) {
            return `
                <div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:BetSlip.CurrentMode.setMaxBet(${selection.ViewKey})">${$dict.bs("MaxBet")}</a></div>
            `;
        }

        return "";
    };
     
    api.createComboMaxBet = function(mode, isFirst) {
        if (isFirst && mode.IsMaxBetButtonEnabled() && !Modes.isCombinatorMode(mode)) {
            return `
                <div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:BetSlip.CurrentMode.setComboMaxBet('combo_options')">${$dict.bs("MaxBet")}</a></div>
            `;
        }

        return "";
    };

    api.createUKComboMaxBet = function(selection, mode, selections) {
        if(isEnabledMaxBetForMultiSelectionUK(mode, selections)) {
            return `<div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:BetSlip.CurrentMode.setComboMaxBet(${selection.key})">${$dict.bs("MaxBet")}</a></div>`;
        }

        return "";
    };

    api.createUKSystemMaxBet = function(selection, mode, selections) {
        if(isEnabledMaxBetForMultiSelectionUK(mode, selections)) {
            return `<div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:BetSlip.CurrentMode.setSystemMaxBet(${selection.key})">${$dict.bs("MaxBet")}</a></div>`;
        }

        return "";
    };

    api.createSystemMaxBet = function(mode) {
        if(mode.IsMaxBetButtonEnabled()) {
            return `<div class="betslip-maxbet-button" data-uat="bet-slip-max-bet-button"><a href="javascript:SystemSPSlipMode.SetComboMaxBet()"> ${$dict.bs("MaxBet")}</a></div>`;
        }

        return "";
    };

	api.buildGeolocationInProggress = function (mode) {
		return mode.isRunningGeoCheck 
			? `<div class="betSlip-message betSlip-message--geolocation" data-uat="betSlip-message--geolocation">${$dict.bs("GeolocationInProgress")}</div>`
			: ``;
	}

    api.buildMaxBetMessage = function (mode, selections) {
        var isEnabled = BetSlip.IsBetslipUK ? selections.any(isEnabledMaxBetForSingleSelectionUK) :
            Modes.isSingleMode(mode) ? selections.any(function(s) {return mode.IsMaxBetButtonEnabled(s)}) :
            mode.IsMaxBetButtonEnabled();
        if(isEnabled && BetSlip.getSelectionsCount()) {
            return `<div class="betting_slip__maxbetMessage" data-uat="bet-slip-max-bet-message">${$dict.bs("RequestAmount")}</div>`;
        }

        return "";
    };

    api.bookBetShowPopup = function () {
        var lastCode = BookABet.getLastCode() || '';
        var lastQrCode = BookABet.getLastQrCode() || '';

        var html = `<div class="book-a-bet-popup">
            <div class="book-a-bet-popup-img">${lastQrCode}</div>
            <p class="book-a-bet-popup-code">${lastCode}</p>
            <p class="book-a-bet-popup-description">${$dict.bs("BookABetQrDescription")}</p>
        </div>`;

        UI.message.show({
            body: html
        });
    }

    api.buildBookABet = function () {
        if (!BetSlip.config.EnableBookABet) {
            return "";
        }
    
        var lastCode = BookABet.getLastCode() || '';
        var lastQrCode = BookABet.getLastQrCode() || '';
        var codeVisibleClass = lastCode ? 'code-visible' : '';
        var isHiddenClass = BookABet.getIsBookABetVisible() ? '' : 'hidden';
        var enableBookABetQrCode = BetSlip.config.EnableBookABet.EnableBookABetQrCode;
        
        return `
            <div class="book-a-bet-container clearfix ${isHiddenClass} ${codeVisibleClass}" data-uat="bet-shop-block-create">
                <div class="book-a-bet-container-border">
                    <div class="get-code-container">
                        <span class="icon i-24 i-o-betslip-qrcode book-a-bet-button-icon"></span>
                        <button id="BookABetButton" class="book-a-bet-button" onclick="BookABet.bookBet()" data-uat="bet-shop-button">
                            ${$dict.bs("GetBetshopCode")}
                        </button>
                    </div>
                    <div class="code-container">
                        ${enableBookABetQrCode ? 
                        `
                            <div class="book-a-bet-qr">
                                ${lastQrCode}
                            </div>
                            <div class="book-a-bet-description">
                                <span class="book-a-bet-message" data-uat="bet-shop-message">${$dict.bs("BookABetQrDescription")}</span>
                                <div class="book-a-bet-code-wrap">
                                    <span class="book-a-bet-code" data-uat="bet-shop-code">${lastCode}</span>
                                    <button class="book-a-bet-popup-button" onclick="TSlipShared.bookBetShowPopup()">
                                        <span class="icon i-24 i-o-betslip-download book-a-bet-popup-icon"></span>
                                    </button>
                                </div>
                            </div>
                        ` :
                        `
                            <span class="book-a-bet-message" data-uat="bet-shop-message">${$dict.bs("YourBetslipCodeIs")}</span>
                            <span class="book-a-bet-code" data-uat="bet-shop-code">${lastCode}</span>
                        `
                    }
                    </div>
                </div>
            </div>
        `;
    };

    api.createBetTypeRow = function (lineEventTypeName: string, selection, tsSelection, mode) {
        return `
			${this.createScoreDescription(selection, tsSelection, mode)}
			${lineEventTypeName}
        `;
    };

    function isEnabledMaxBetForMultiSelectionUK(mode, selections) {
        var hasLiveSelections = selections.any(function(s) {
            return s.Live;
        });
        return UserInfo.current && mode.shouldShowMaxbetButtonForMultiSelections(hasLiveSelections);
    }

    function isEnabledMaxBetForSingleSelectionUK(selection) {
        var enabledForLiveSelections = BetSlip.ShowMaxBetButtonLive && selection.Live;
        var enabledForPrematchSelections = BetSlip.ShowMaxBetButtonPrematch && !selection.Live;
        return UserInfo.current && (enabledForLiveSelections || enabledForPrematchSelections) && selection.Valid && selection.maxBet >= 1;
    }
    return api;
}());

window.TSlipShared = TSlipShared;
jsRequire("/templates/Mobile/UniSlip/TSlipShared.ext.js");
